import { type PayerBase, type TransactionItemDetail, getUserName } from 'models';
import { useTranslation } from 'react-i18next';
import { Avatar, Col, Row, Text, useFormatPrice } from 'ui';
import { useUser } from 'features/auth';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { AvatarLink, UserNameLink, UserPopover } from 'features/users/components';
import { useGetTransactionItemDate } from '../../../../hooks';

type P = {
  transactionItem: TransactionItemDetail;
  user: PayerBase;
};

const UserDetailed = ({ transactionItem, user }: P) => {
  const { railsUserData: viewer } = useUser();
  const { t } = useTranslation();
  const formatPrice = useFormatPrice();
  const date = useGetTransactionItemDate({ transactionItem });
  const name = getUserName(user);

  return (
    <Row align="middle" gutter={['xs', 0]}>
      <Col>
        {user.id ? (
          // TS doesn't narrow optional id on object, so we recreate it with required id
          <UserPopover user={{ ...user, id: user.id }}>
            <AvatarLink
              avatar={{
                alt: t('userAvatarProfilePhoto', { name }),
                photo: user.profilePhoto,
                size: 32,
              }}
              userId={user.id}
            />
          </UserPopover>
        ) : (
          <Avatar alt={t('userAvatarProfilePhoto', { name })} photo={user.profilePhoto} size={32} />
        )}
      </Col>

      <Col flex="auto">
        {user.id ? (
          // TS doesn't narrow optional id on object, so we recreate it with required id
          <UserPopover user={{ ...user, id: user.id }}>
            <UserNameLink type="text" userId={user.id}>
              {user.id === viewer.id ? t('listUserName', { name }) : name}
            </UserNameLink>
          </UserPopover>
        ) : (
          <Text type="title" weight="medium">
            {user.id === viewer.id ? t('listUserName', { name }) : name}
          </Text>
        )}

        <br />
        <Text>{`${formatPrice({ value: transactionItem.amount })} · ${date}`}</Text>
      </Col>
    </Row>
  );
};

export default UserDetailed;
